import PropTypes from "prop-types";

// material
import { alpha, styled } from "@mui/material";
import {
  _status,
  DOC_STATUS,
  LABEL_TYPE,
  ORDER_STATUS,
} from "../utils/Constant";

const RootStyle = styled("span")(({ theme, styleProps }) => {
  const isLight = theme.palette.mode === "light";
  const { color, variant } = styleProps;

  const styleFilled = (color) => ({
    color: theme.palette[color[0]].contrastText,
    backgroundColor:
      theme.palette[color[0]][
      color[1]
      ] /* Ex : will work like theme.palatte.success.main */,
  });

  const styleOutlined = (color) => ({
    color: theme.palette[color[0]][color[1]],
    backgroundColor: "transparent",
    border: `1px solid ${theme.palette[color[0]][color[1]]}`,
  });

  const styleGhost = (color) => ({
    color: theme.palette[color[0]][isLight ? "dark" : "light"],
    backgroundColor: alpha(theme.palette[color[0]][color[1]], 0.16),
  });

  return {
    height: 22,
    minWidth: 22,
    lineHeight: 0,
    borderRadius: 8,
    cursor: "default",
    alignItems: "center",
    whiteSpace: "nowrap",
    display: "inline-flex",
    justifyContent: "center",
    padding: theme.spacing(0, 1),
    color: theme.palette.grey[800],
    fontSize: theme.typography.pxToRem(12),
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.grey[300],
    fontWeight: theme.typography.fontWeightBold,

    ...(color !== "default"
      ? {
        ...(variant === "filled" && { ...styleFilled(color) }),
        ...(variant === "outlined" && { ...styleOutlined(color) }),
        ...(variant === "ghost" && { ...styleGhost(color) }),
      }
      : {
        ...(variant === "outlined" && {
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
          border: `1px solid ${theme.palette.grey[500_32]}`,
        }),
        ...(variant === "ghost" && {
          color: isLight
            ? theme.palette.text.secondary
            : theme.palette.common.white,
          backgroundColor: theme.palette.grey[500_16],
        }),
      }),
  };
});

// ----------------------------------------------------------------------

export default function Label({
  color,
  variant = "ghost",
  children,
  type = LABEL_TYPE.STATUS,
  value = "",
  icon = null,
  others,
}) {
  const _statusMap = {
    [_status.inactive]: ["error", "main"],
    [_status.active]: ["success", "main"],
    [_status.pending]: ["warning", "main"],
  };

  const _docStatusMap = {
    [DOC_STATUS.PENDING]: ["secondary", "main"],
    [DOC_STATUS.NOT_VERIFIED]: ["error", "main"],
    [DOC_STATUS.VERIFIED]: ["success", "main"],
  };

  const _orderStatusMap = {
    [ORDER_STATUS.CONFIRMED]: ["warning", "main"],
    [ORDER_STATUS.COMPLETED]: ["success", "main"],
    [ORDER_STATUS.PICKUP]: ["secondary", "main"],
    [ORDER_STATUS.READY_FOR_PICKUP]: ["success", "main"],
    [ORDER_STATUS.PHOTO_CAPTURE]: ["primary", "light"],
  };


  switch (type) {
    case LABEL_TYPE.STATUS:
      color = _statusMap[value];
      break;
    case LABEL_TYPE.DOC_STATUS:
      color = _docStatusMap[value];
      break;
    case LABEL_TYPE.ORDER_STATUS:
      color = _orderStatusMap[value];
      break;
    default:
      color = [color || "primary", "main"];
      break;
  }
  if (!color) return <></>;
  return (
    <RootStyle styleProps={{ color, variant }} {...others}>
      {
        typeof children === 'string' ? children?.replace(/_/g," ") : children 
      }
    </RootStyle>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  color: PropTypes.oneOf([
    "default",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
  ]),
  variant: PropTypes.oneOf(["filled", "outlined", "ghost"]),
  status: PropTypes.oneOf(["status"]),
  value: PropTypes.string | PropTypes.number,
};
